// Action Types
export const EVENT_CONFIG_FETCH_REQUEST = "EVENT_CONFIG_FETCH_REQUEST";
export const EVENT_CONFIG_FETCH_SUCCESS = "EVENT_CONFIG_FETCH_SUCCESS";
export const EVENT_CONFIG_FETCH_FAILURE = "EVENT_CONFIG_FETCH_FAILURE";
export const EVENT_CONFIG_UPDATE_REQUEST = "EVENT_CONFIG_UPDATE_REQUEST";
export const EVENT_CONFIG_UPDATE_SUCCESS = "EVENT_CONFIG_UPDATE_SUCCESS";
export const EVENT_CONFIG_UPDATE_FAILURE = "EVENT_CONFIG_UPDATE_FAILURE";
export const EVENT_CONFIG_TOGGLE_CHANNEL = "EVENT_CONFIG_TOGGLE_CHANNEL";
export const EVENT_CONFIG_CLEAR_ERROR = "EVENT_CONFIG_CLEAR_ERROR";
